/**
 * ROUND7 - breaching walls (docs/milestones/ROUND7-contracts.md §4). The numbers were measured on generated
 * munitions-depot maps by tests/unit/wallsBreach.test.ts, which holds them to the widths promised below.
 */

export const WALLS = {
  /**
   * A blast takes wall within its radius times this, measured from the blast to each piece's nearest face: a LAW
   * (5 m) reaches 1 m along the wall either way, a time bomb laid against it (9 m) 1.8 m. Every other hard prop
   * keeps the 0.55 it had.
   *
   * Why 0.2 and not the first guess of 0.3: a breach takes WHOLE pieces, so the gap is the reach both ways plus,
   * on average, one piece - about 2 x reach + `pieceMax`. At 0.3 a LAW opened 4.4-5.8 m and a bomb 6.8-8.7 m;
   * at 0.2 a LAW opens about 3 m and a bomb about 5 m, which is what the contract promised the player.
   */
  breachReachFactor: 0.2,
  /** The longest wall piece the generator lays, metres: a breach opens a gap a few pieces wide. */
  pieceMax: 1.5,
  /**
   * A thrown grenade's arc: its highest point is this fraction of the throw's length above the ground, within
   * these bounds - and never below the hand it leaves (`grenadeHand`). A short lob barely rises, so thrown at a
   * wall from close it strikes the wall; a long one clears a man-high wall except where it is still rising off
   * the hand or already coming down on the far side.
   */
  grenadeApex: { fraction: 0.35, min: 1.4, max: 4 },
  /** Where a thrown grenade leaves the hand, metres: the throw sites start it at this height. */
  grenadeHand: 1.4,
  /**
   * Thrown and fired things cross the ground as a ball this big in radius, not as a point: an east or west face is
   * a column of pieces with 0.4 m slits between their colliders (box colliders cannot turn), and neither a grenade
   * nor a rocket may thread one of those.
   */
  body: 0.2,
  /** A grenade stopped by something too tall to clear drops this far short of where it struck, metres. */
  dropBack: 0.15,
} as const;
